module.exports = __webpack_public_path__ + "static/media/Path 3569.81f85896.svg";